<template>
  <div>
    <v-chip
      v-for="service in getServicesForIds(note.salon_appointment_service_id)"
      :key="service.id"
      size="x-small"
      :class="`bg-${getTitleColor(service)}`"
    >
      {{ service.description }}
    </v-chip>
  </div>
</template>

<script>
import { servicesList } from "../../../libs/options";
import { getTitleColor } from "../../../libs/util";
export default {
  name: "NoteServices",
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const apiURL = import.meta.env.VITE_API_URL;
    return { apiURL, servicesList, getTitleColor };
  },
  methods: {
    getServicesForIds(ids) {
      const idsArray = JSON.parse(ids);
      const services = this.servicesList.filter((service) =>
        idsArray.includes(service.id)
      );
      return services;
    },
  },
};
</script>
